var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymbotIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "symbot-icon-blue",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 347.27 313.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#498af6",
    d: "M336.38,155.44c-4.71-6.29-10.75-9.38-18.5-10.3-5.37-24.01-19.3-41.36-40.03-53.91-32.97-19.96-74.99-26.68-113.1-27.03l-1.97-13.81c35.46-8.73,18.33-61.67-15.63-48.22-21.9,8.68-20.55,41.41,2.26,47.63l-2.54,15.04c-32.39,2.44-67.24,10.65-94.01,29.67-16.15,11.47-24.82,24.39-29.73,43.67-.86,3.36-2.8,17.68-3.67,19.1-.23.37-5.88,3.51-7.28,4.75-15.32,13.6-13.08,43.35-9.81,61.71,2.53,14.22,6.44,27.67,22.97,29.85,3.23,9.57,8,19.1,14.7,26.74,9.97,11.36,29.17,17.19,43.5,21.03,53.4,14.29,155.13,22.37,202.15-10.69,14.87-10.46,20.8-24.54,25.83-41.56,10.32.24,20.73-1.02,26.18-10.83,11.97-21.56,13.98-62.46-1.32-82.84ZM263.87,232.77c-18.65,25.53-75.33,11.53-103.33,9.93-27.98-1.59-49.43,2.12-76.62,4.97-1.75.18-3.49.48-5.25.58-1.89.11-3.8.09-5.64.56-3.61.91-6.65,3.53-9.76,5.46-2.46,1.53-4.92,3.06-7.38,4.59-4.49,2.79-8.98,5.58-13.47,8.37-.8.5-1.61,1-2.41,1.5-.11.07-.89.43-.91.56.43-3.23.86-6.47,1.29-9.7.48-3.56.95-7.13,1.42-10.69.39-2.9,1.06-5.87,1.22-8.79.11-2.1-1.27-3.23-2.26-4.92-.78-1.34-1.48-2.74-2.1-4.17-1.21-2.78-2.14-5.68-2.94-8.6-1.46-5.3-2.39-10.73-3.01-16.19-.68-6.02-.97-12.09-.95-18.15s.37-12.59,1.03-18.85,1.61-12.25,2.93-18.29c1.22-5.58,2.75-11.1,4.75-16.45,1.73-4.64,3.8-9.19,6.48-13.36.44-.69.9-1.37,1.38-2.03,17.96-24.84,81.51-33.83,110.48-35.03,27.6-1.15,84,1.47,102.88,24.54,20.26,24.75,20.85,98.56,2.15,124.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#498af6",
    x: 149.47,
    y: 121.64,
    width: 14.95,
    height: 14.95,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#498af6",
    x: 149.47,
    y: 196.34,
    width: 14.95,
    height: 14.95,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#498af6",
    d: "M213.37,210.12c.33.47,0,1.16-.61,1.16h-18.71c-.39,0-.78-.15-1.06-.43l-17.91-17.91c-3.39-3.55-6.04-7.7-7.85-12.18-1.8-4.49-2.75-9.31-2.75-14.24,0-10.16,4.03-19.89,11.21-27.07l17.57-17.57c.26-.19.57-.3.88-.3h18.72c.67,0,1,.81.53,1.28l-13.87,13.87-24.48,24.47c-1.46,1.47-2.19,3.39-2.18,5.3,0,1.92.72,3.84,2.18,5.31l24.36,24.35,13.96,13.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#498af6",
    d: "M149.43,166.52c0,4.93-.95,9.75-2.75,14.24-1.8,4.49-4.45,8.63-7.85,12.18l-17.91,17.91c-.28.28-.66.44-1.06.44h-18.72c-.62,0-.94-.7-.61-1.17l38.31-38.31c1.47-1.47,2.2-3.39,2.19-5.31,0-1.91-.72-3.83-2.19-5.3l-24.36-24.36-13.98-13.98c-.47-.47-.14-1.28.53-1.28h18.72c.32,0,.63.11.89.3l17.57,17.57c7.18,7.18,11.21,16.92,11.21,27.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbotIconBlue);
export default __webpack_public_path__ + "static/media/symbot-icon-blue.e1bb13662f655d8b275ed2440c24e870.svg";
export { ForwardRef as ReactComponent };